// Formats a Date to the local "YYYY-MM-DDTHH:MM" string <input type="datetime-local"> expects.
function formatLocal(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Default widget date range: the last `hoursBack` hours, ending now.
 */
export function getDefaultTimeRange(hoursBack = 6) {
  const now = new Date();
  const start = new Date(now.getTime() - hoursBack * 60 * 60 * 1000);
  return { start: formatLocal(start), end: formatLocal(now) };
}
